import React from 'react';
type Tone = 'outline' | 'accent' | 'quiet';
interface PillProps {
  children: React.ReactNode;
  onClick: () => void;
  tone?: Tone;
  className?: string;
  'aria-expanded'?: boolean;
}
const TONES: Record<Tone, string> = {
  outline: 'border-white/25 text-white/85 hover:border-solventum-primary hover:text-solventum-primary',
  accent: 'border-solventum-primary bg-solventum-primary text-solventum-bg hover:bg-solventum-primary/90',
  quiet: 'border-transparent text-white/40 hover:text-white/70'
};

/**
 * The single interaction affordance in this edition: a small, thin-outlined
 * pill. Understated on purpose — never a full-width button.
 */
export function Pill({
  children,
  onClick,
  tone = 'outline',
  className = '',
  ...rest
}: PillProps) {
  return <button onClick={onClick} {...rest} className={`inline-flex items-center gap-1.5 rounded-full border px-4 py-2 font-body text-xs tracking-wide transition-[color,border-color,background-color,transform] duration-150 ease-out active:scale-[0.97] ${TONES[tone]} ${className}`} data-id="element-126" data-mp="31e9kfudogvgn">
      {children}
    </button>;
}